export default "__VITE_PUBLIC_ASSET__f8ed1f71__"